import React, { useState } from 'react';
import folder_closed from '../assets/folder_closed.svg';
import folder_open from '../assets/folder_open.svg';
import tasks from '../assets/tasks.svg';
import paper from '../assets/paper.svg';
import project_arrow from '../assets/project_arrow.svg';
import { styled } from '@mui/material/styles';
import project_warning from '../assets/project_warning.svg';
import project_error from '../assets/project_error.svg';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import project_error_orange from '../assets/project_error_orange.svg';

function ProjectItem({project,handleClick}) {
    const [isHovering, setIsHovering] = useState(false);
    const handleMouseOver = () => {
        setIsHovering(true);
      };
    
      const handleMouseOut = () => {
        setIsHovering(false);
      };
      const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip placement="right" {...props} arrow classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
          color: '#265E85',
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: '#265E85',
        },
      }));
  return (
    <div 
    key={project.ProjectID} 
    className={isHovering ? 'project-container-hover' : 'project-container' }
    onMouseOver={handleMouseOver} 
    onMouseOut={handleMouseOut}
    onClick={()=>handleClick(project.ProjectID)}
    >
        <div className='project-name' >
         <img src={isHovering ? folder_open : folder_closed} alt='#'/> 
         &nbsp; 
         {project.ProjectName ? 
            project.ProjectName.length > 50 ? project.ProjectName.slice(0, 50)+'...' : project.ProjectName
          : ''}
          &nbsp; 
          {
            project.nb_expenses > 0 ?
            <BootstrapTooltip title="New imported expenses to link">
          <img src={project_warning} alt='#'/>
          </BootstrapTooltip>
          : <></>
          }
          &nbsp; 
          {Math.round(project.Forecasted) < Math.round(project.Spent) ?
          <BootstrapTooltip title="Actuals exceed forecast at project level">
           <img src={project_error} alt='#'/> 
      </BootstrapTooltip>
      : <></>}
      &nbsp; 
          {
            project.nb_error_task > 0 ?
            <BootstrapTooltip title="Actuals exceed forecast at task level">
          <img src={project_error_orange} alt='#'/> 
          </BootstrapTooltip>
          : <></>
          }
        </div>
        <div className='project-task' >
            <img src={tasks} alt='#'/> &nbsp; {project.nb_task} tasks
        </div>
        <div className='project-amount' >
           <img src={paper} alt='#'/> &nbsp; {Math.round(project.Forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </div>
        <div className='project-arrow' >
            <img src={project_arrow} alt='#'/>
        </div>
    </div>
  )
}

export default ProjectItem